import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo, Button, inputClass } from "@/components/base";
import { api, errMsg } from "@/lib/api";
import { metaTrack } from "@/lib/meta";
import { useAuth } from "@/lib/auth";
import ThemeToggle from "@/components/ThemeToggle";

const COUNTRIES = [
  { id: "FR", code: "+33" },
  { id: "BE", code: "+32" },
  { id: "CH", code: "+41" },
  { id: "LU", code: "+352" },
];

const Check = ({ checked, onChange, testId, children }) => (
  <label className="flex cursor-pointer items-start gap-3 text-[14px] leading-snug text-ink">
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testId} className="mt-0.5 h-[18px] w-[18px] shrink-0 cursor-pointer rounded accent-[color:var(--text)]" />
    <span>{children}</span>
  </label>
);

// Mandatory after Google or magic link when no phone/consent yet. Nothing else is reachable before it.
export default function PhoneGate() {
  const { setUser } = useAuth();
  const [f, setF] = useState({ country: "FR", phone: "", consent: false, reminders: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    if (f.phone.replace(/\D/g, "").length < 8) return setErr("Entre un numéro de mobile valide.");
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/me/phone", f);
      metaTrack("Lead", r.data.meta_event_id);
      setUser(r.data.user);
    } catch (e2) {
      setErr(errMsg(e2, "Entre un numéro de mobile valide."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-dvh bg-bg" data-testid="phone-gate">
      <header className="flex h-14 items-center justify-between px-5">
        <Logo to="#" />
        <ThemeToggle testId="phone-gate-theme-toggle" />
      </header>
      <main className="mx-auto max-w-[440px] px-5 pt-10">
        <h1 className="text-[26px] font-semibold tracking-[-0.02em] text-ink" data-testid="phone-gate-title">
          Ton numéro de mobile
        </h1>
        <p className="mt-2 text-[15px] leading-relaxed text-muted">Pour qu'on puisse te rappeler si tu réserves une session.</p>
        <form onSubmit={submit} noValidate className="mt-6 flex flex-col gap-4">
          <div className="flex gap-2">
            <select aria-label="Pays" data-testid="phone-gate-country" value={f.country} onChange={(e) => set("country")(e.target.value)} className={`${inputClass.replace("w-full", "")} w-[124px] shrink-0 cursor-pointer px-3`}>
              {COUNTRIES.map((c) => (
                <option key={c.id} value={c.id}>{`${c.id} (${c.code})`}</option>
              ))}
            </select>
            <input className={`${inputClass} min-w-0 flex-1`} type="tel" inputMode="tel" placeholder="Mobile" aria-label="Téléphone mobile" autoComplete="tel-national" data-testid="phone-gate-phone" value={f.phone} onChange={(e) => set("phone")(e.target.value)} />
          </div>
          {err && <p className="err-msg text-[13px] text-ink" data-testid="phone-gate-error">{err}</p>}
          <Check checked={f.consent} onChange={set("consent")} testId="phone-gate-consent">
            J'accepte que mes données soient utilisées pour créer mon compte, selon la{" "}
            <Link to="/confidentialite" target="_blank" className="underline underline-offset-2">
              politique de confidentialité
            </Link>
            .
          </Check>
          <Check checked={f.reminders} onChange={set("reminders")} testId="phone-gate-reminders">
            J'accepte de recevoir mes rappels et conseils par email
          </Check>
          <Button type="submit" disabled={!f.consent || busy} data-testid="phone-gate-submit" className="mt-1 w-full">
            {busy ? "Enregistrement..." : "Continuer"}
          </Button>
        </form>
      </main>
    </div>
  );
}
